"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var math = __importStar(require("mathjs"));
var React = __importStar(require("react"));
var utils_1 = require("../../../utils");
var calculations_1 = require("../../../utils/calculations");
var PanelCard_1 = __importDefault(require("../../PanelCard"));
var ResultsTable_1 = __importDefault(require("../../ResultsTable"));
var columns_1 = __importDefault(require("./columns"));
var CannabinoidsCard = function (_a) {
    var result = _a.result, stateRegulations = _a.stateRegulations, moistureContentPercentage = _a.moistureContentPercentage, density = _a.density, isSolid = _a.isSolid, amountPerPackage = _a.amountPerPackage, amountPerServing = _a.amountPerServing, rest = __rest(_a, ["result", "stateRegulations", "moistureContentPercentage", "density", "isSolid", "amountPerPackage", "amountPerServing"]);
    return (React.createElement(PanelCard_1.default, __assign({}, rest, { panelName: "Cannabinoids", instrumentName: result.instrumentUsed.name, method: result.panel.standardOperatingProcedures[0].name, addPassFail: false, additionalAttributes: [
            {
                title: "Total THC",
                value: (function () {
                    var _a;
                    var totalTHC = calculations_1.deriveTotalTHC(result, moistureContentPercentage, density, result.instrumentUsed.instrumentParameters);
                    if (typeof totalTHC === "string")
                        return totalTHC;
                    if (totalTHC <= 0)
                        return "ND";
                    var totalTHCPPT = math
                        .unit(totalTHC, utils_1.convertFromDisplayUnits(isSolid
                        ? lodash_1.get(result.instrumentUsed.instrumentParameters.find(function (_a) {
                            var rawName = _a.referenceComponent.rawName;
                            return rawName === "d9-THC";
                        }), "weightUnitOfMeasure", "ug/g")
                        : lodash_1.get(result.instrumentUsed.instrumentParameters.find(function (_a) {
                            var rawName = _a.referenceComponent.rawName;
                            return rawName === "d9-THC";
                        }), "volumeUnitOfMeasure", "ug/mL")))
                        .to(isSolid ? "mg/g" : "mg/mL");
                    return calculations_1.convertPpmToPercent(totalTHC).toFixed(3) + "%, " + totalTHCPPT
                        .format({ notation: "fixed", precision: 2 })
                        .toString()
                        .replace(" / ", "/") + (amountPerPackage
                        ? ", " + math
                            .unit(totalTHC * ((_a = amountPerPackage.value) !== null && _a !== void 0 ? _a : 0), "ug")
                            .to("mg")
                            .toJSON()
                            .value.toFixed(2) + " " + (isSolid ? "mg/package" : "mL/package")
                        : "");
                })(),
            },
            {
                title: "Total CBD",
                value: (function () {
                    var _a;
                    var totalCBD = calculations_1.deriveTotalCBD(result, moistureContentPercentage, density, result.instrumentUsed.instrumentParameters);
                    if (typeof totalCBD === "string")
                        return totalCBD;
                    if (totalCBD <= 0)
                        return "ND";
                    var totalCBDPPT = math
                        .unit(totalCBD, utils_1.convertFromDisplayUnits(isSolid
                        ? lodash_1.get(result.instrumentUsed.instrumentParameters.find(function (_a) {
                            var rawName = _a.referenceComponent.rawName;
                            return rawName === "d9-THC";
                        }), "weightUnitOfMeasure", "ug/g")
                        : lodash_1.get(result.instrumentUsed.instrumentParameters.find(function (_a) {
                            var rawName = _a.referenceComponent.rawName;
                            return rawName === "d9-THC";
                        }), "volumeUnitOfMeasure", "ug/mL")))
                        .to(isSolid ? "mg/g" : "mg/mL");
                    return calculations_1.convertPpmToPercent(totalCBD).toFixed(3) + "%, " + totalCBDPPT
                        .format({ notation: "fixed", precision: 2 })
                        .toString()
                        .replace(" / ", "/") + (amountPerPackage
                        ? ", " + math
                            .unit(totalCBD * ((_a = amountPerPackage.value) !== null && _a !== void 0 ? _a : 0), "ug")
                            .to("mg")
                            .toJSON()
                            .value.toFixed(2) + " " + (isSolid ? "mg/package" : "mL/package")
                        : "");
                })(),
            },
            {
                title: "Total Cannabinoids",
                value: (function () {
                    var totalCannabinoids = calculations_1.deriveTotalCannabinoids(result, moistureContentPercentage, density, result.instrumentUsed.instrumentParameters);
                    if (typeof totalCannabinoids === "string")
                        return totalCannabinoids;
                    if (totalCannabinoids <= 0)
                        return "ND";
                    var totalCannabinoidsPPT = math
                        .unit(totalCannabinoids, utils_1.convertFromDisplayUnits(isSolid
                        ? lodash_1.get(result.instrumentUsed.instrumentParameters.find(function (_a) {
                            var rawName = _a.referenceComponent.rawName;
                            return rawName === "d9-THC";
                        }), "weightUnitOfMeasure", "ug/g")
                        : lodash_1.get(result.instrumentUsed.instrumentParameters.find(function (_a) {
                            var rawName = _a.referenceComponent.rawName;
                            return rawName === "d9-THC";
                        }), "volumeUnitOfMeasure", "ug/mL")))
                        .to(isSolid ? "mg/g" : "mg/mL");
                    return calculations_1.convertPpmToPercent(totalCannabinoids).toFixed(3) + "%, " + totalCannabinoidsPPT
                        .format({ notation: "fixed", precision: 2 })
                        .toString()
                        .replace(" / ", "/");
                })(),
            },
        ], table: React.createElement(ResultsTable_1.default, { columns: columns_1.default({ amountPerPackage: amountPerPackage, amountPerServing: amountPerServing }), rows: utils_1.defaultBuildRows({
                parameters: result.instrumentUsed.instrumentParameters,
                stateRegulations: stateRegulations,
                results: result.results,
                moistureContentPercentage: moistureContentPercentage,
                density: density,
                isSolid: isSolid,
                amountPerServing: amountPerServing,
                amountPerPackage: amountPerPackage,
            }) }) })));
};
exports.default = CannabinoidsCard;
//# sourceMappingURL=index.js.map